var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sms-broadcast-preview-message"},[(!_vm.message)?[_vm._v(" "+_vm._s(_vm.$t('defaultMessage'))+" ")]:(_vm.messageValues.length === 1)?[_vm._v(" "+_vm._s(_vm.messageValues[0].value)+" ")]:_vm._l((_vm.messageValues),function(ref,i){
var value = ref.value;
var showError = ref.showError;
return _c('span',{key:i,class:{ error: showError }},[_vm._v(_vm._s(value))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }